<template>
  <div>
    <div class="flex flex-wrap justify-center p2 px3">
      <div class="col-12  flex ">
        <h3 class="col-12">
          1 &nbsp; {{ getReferencelabel('ABOUT_CHARGE_WALLET') }} {{ wallet.holder.firstname }} {{ wallet.holder.lastname }} {{ getReferencelabel("AT") }} {{ getCenterName(wallet.center) }}
        </h3>
      </div>

      <WalletInformation :wallet="wallet" />

      <Alert v-if="showPayboxError" message="Une erreur de paiement s'est produite, veuillez réessayer" color="error" icon="attention" class="my2" />
      <h3 class="col-12">2 &nbsp; {{ getReferencelabel("ENTER_AMOUNT") }}</h3>

      <div class="col-12 md-col-8  flex items-center justify-center  flex flex-wrap" style="border: 1px ">
        <label for="visa-card" class="pointer p1 m1 white-bg" style="border: 1px solid; width:190px;">
          <div class="flex items-center justify-between">
            <input id="visa-card" v-model="cardType" value="visa" type="radio">
            <img class="mr3" src="/espacepersonnel/fonts/logo-visa.png">
          </div>
        </label>
        <label for="blue-card" class="pointer p1 m1 white-bg" style="border: 1px solid; width:190px;">
          <div class="flex items-center  justify-between">
            <input id="blue-card" v-model="cardType" value="cb" type="radio">
            <img class="mr3" src="/espacepersonnel/fonts/logo-carte-bleu.png">
          </div>
        </label>
        <label for="master-card" class="pointer p1 m1 white-bg" style="border: 1px solid; width:190px;">
          <div class="flex items-center justify-between">
            <input id="master-card" v-model="cardType" value="eurocard_mastercard" type="radio">
            <img class="mr3" src="/espacepersonnel/fonts/logo-mastercard.png">
          </div>
        </label>
      </div>

      <div class="col-12 md-col-8 flex flex-wrap justify-between items-center  pt1">
        <div class="col-12 md-col-6 lg-col-7 mt1 relative">
          <input v-model="amount" class="input-field right-align  border-none col-12 pr4" type="number" style="height:55px; font-size:18px;" :placeholder="getReferencelabel('EXAMPLE_10')">
          <i class="icon-input icon-euro"> </i>
        </div>

        <Button
          reference="SUBMIT"
          class="col-12 md-col-5 lg-col-4 mt1"
          btn-color="blue"
          style="height:55px;"
          :loading="buttonLoading"
          :disabled="!(amount && cardType)"
          :action="checkPayment"
        />
      </div>
    </div>

    <!-- PAYBOX EVENT -->

    <div ref="payboxElement" class="hidden" v-html="payboxHTML"> </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ref, nextTick } from 'vue';
import Button from '@/components/elements/Button';
import WalletInformation from '@/components/services/WalletInformation';
import Alert from '@/components/common/Alert';

import { getPayboxForm } from '@/mixins/requests';
import { getCenterName, getReferencelabel } from '@/mixins/utils';

export default {
  components: {
    Button,
    WalletInformation,
    Alert
  },
  setup () {
    const route = useRoute();
    const store = useStore();
    const amount = ref('');
    const payboxHTML = ref('');
    const payboxElement = ref(null);
    const showPayboxError = ref(false);
    const buttonLoading = ref(false);
    const cardType = ref(null);

    const wallet = store.state.wallets.find(a => a.uuid === route.params.id);

    async function checkPayment () {
      buttonLoading.value = true;

      const payboxForm = {
        amount: amount.value,
        wallet_id: wallet.uuid,
        language: store.state.selectedLanguage || 'fr',
        cardType: cardType.value
      };

      const response = await getPayboxForm(payboxForm);
      amount.value = '';
      payboxHTML.value = response.data.payboxHTML;

      if (payboxHTML.value.indexOf('Erreur PAYBOX') < 0 && response.success) {
        nextTick(() => {
          payboxElement.value.getElementsByTagName('form')[0].submit();
        });
      } else {
        showPayboxError.value = true;
      }
    }

    return { wallet, checkPayment, amount, payboxHTML, payboxElement, showPayboxError, buttonLoading, getCenterName, getReferencelabel, cardType };
  }
};
</script>

<style>

</style>
